import React from "react";
import {
  Container,
  Typography,
  ButtonGroup,
  Button,
  CssBaseline,
} from "@mui/material";
import "./App.css";
function App() {
  //by the time we render we should also id the use by an unique id and store on firestore to track progress of the steps and attach info to.
  return (
    <CssBaseline>
      <div className="App">
        <Container>
          <Typography>Monte seu cultivo em 5 minutos!</Typography>
          <Typography>
            Entenda tudo que você precisa para começar a cultivar Indoor (dentro
            de casa), os custos, os materiais e ainda de quebra receber um
            relatório completo no seu Email ou WhatsApp mais um Ebook Gratuito
            para você começar com sucesso! Essa é uma ferramenta feita pela
            Homegrown, sem custos!
          </Typography>
          <Typography>
            Em 5 minutos você vai ter o seu resultado completo! Bora começar?
          </Typography>
          <ButtonGroup aria-label="text button group">
            <Button
              sx={{ paddingRight: 5, paddingLeft: 5 }}
              variant="contained"
            >
              Bora!
            </Button>
            <Button variant="outlined">Não, mas gostaria de um eBook</Button>
          </ButtonGroup>

          <Typography>
            Você já teve sucesso cultivando em casa? Por sucesso eu digo,
            plantar, colher e poder consumir o seu.
          </Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Não, seria primeira vez</Button>
            <Button>Já cultivei com resultados</Button>
          </ButtonGroup>

          <Typography>
            Um Cultivo Discreto é importante para você cultivar em casa?
          </Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Sim</Button>
            <Button>Não, eu moro no Uruguay</Button>
          </ButtonGroup>

          <Typography>Quantas plantas gostaria de cultivar?</Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Duas até quatro plantas</Button>
            <Button>Mais que 4 plantas</Button>
          </ButtonGroup>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Duas até quatro plantas</Button>
            <Button>Mais que 4 plantas</Button>
          </ButtonGroup>

          {
            //if not first grow
          }
          <Typography>
            Você busca um cultivo completo ou já tem alguns acessórios?
          </Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Sim, Completo e Montado por favor</Button>
            <Button>Não, somente o cultivo e poucos acessórios</Button>
          </ButtonGroup>
          {
            //end if not first grow
          }

          <Typography>Quer/pode investir quanto no seu cultivo?</Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Até R$2500</Button>
            <Button>R$2500 até R$4000</Button>
            <Button>R$4000 ou mais</Button>
          </ButtonGroup>

          <Typography>Você gostaria de acompanhamento de cultivo</Typography>
          <Typography variant="subtitle1">Do inicio a colheita</Typography>

          <ButtonGroup variant="outlined" aria-label="text button group">
            <Button>Sim, por favor</Button>
            <Button>Não, mas gostaria de ter com quem tirar dúvidas</Button>
            <Button>Não, voo solo</Button>
          </ButtonGroup>

          {
            //present top 3 picks
          }
        </Container>
      </div>
    </CssBaseline>
  );
}

export default App;
